import { Avatar, Card, Grid, Stack, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { allEstudiantesDocenteAction } from '../../../control_estudios/estudiantes/EstudiantesAction';
import { PARAMS_ESTUDIANTES_DOCENTE } from '../../../control_estudios/estudiantes/EstudiantesReducer';

const ListadoEstudiantesDocente = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...estudiantesStore.params,
        idEntidad: entidadesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes?.periodoAcademico?.id,
      };

      dispatch({ type: PARAMS_ESTUDIANTES_DOCENTE, payload });

      await allEstudiantesDocenteAction(
        loginStore.isAdminTeacher,
        dispatch,
        loginStore.user.id,
        payload,
      );
    };
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    // const data = materiasStore.all.find((el) => el.id === id);
    // await setActivoMateriasAction(dispatch, data);
    // setOpenModalForm(true);
  };

  // const _handleDeleteClick = async (id) => {
  //   await deleteMateriasAction(
  //     dispatch,
  //     id,
  //     materiasStore.params,
  //     setLoadingDelete
  //   );
  //   setOpenModalDelete(false);
  // };

  const listado = estudiantesStore.allEstudiantesDocente.map((el) => {
    return (
      <Grid item xs={12} md={4}>
        <Card
          sx={{
            p: 2,
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: grey[300],
            },
          }}
          onClick={() => {}}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Avatar
              alt={el.usuario.perfil.pnombre}
              src={
                el.usuario.perfil.avatar
                  ? getFilesArchivos(el.usuario.perfil.avatar)
                  : `static/images/${
                      el.usuario.perfil.gender ? 'userf.png' : 'userm.png'
                    }`
              }
              sx={{ width: 70, height: 70 }}
            />
            <div>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {el.usuario.perfil.tipoDni}-{el.usuario.perfil.dni}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {el.usuario.perfil.pnombre} {el.usuario.perfil.snombre}
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                {el.usuario.perfil.papellido} {el.usuario.perfil.sapellido}
              </Typography>
            </div>
          </Stack>
          {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
          adjective
        </Typography>
        <Typography variant="body2">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography> */}
        </Card>
      </Grid>
    );
  });

  return (
    <Grid container spacing={1}>
      {/* <LoadingWidget
        isLoading={materiasStore.loadingAll || loadingDelete}
        text={loadingDelete ? 'Eliminando registro...' : 'Cargando lista...'}
      /> */}

      {listado}
      {/* {materiasStore.activo ? (
        <ModalComponent
          id="modalDeleteMaterias"
          title={`Eliminar`}
          open={openModalDelete}
          maxWidth="sm"
          onClose={() => setOpenModalDelete(!openModalDelete)}
        >
          <Grid container spacing={1}>
            <Grid item md={12}>
              ¿Seguro que quieres eliminar esta materia?
              <Typography variant="h6">
                {materiasStore.activo.nombre}
              </Typography>
            </Grid>
            <Grid item md={12} align="right">
              <Button
                color="error"
                variant="outlined"
                onClick={async () => {
                  await _handleDeleteClick(materiasStore.activo.id);
                }}
                sx={{ mr: 2 }}
              >
                ELIMINAR
              </Button>
              <Button
                sx={{ color: BLUE_COLOR }}
                onClick={() => setOpenModalDelete(false)}
              >
                CANCELAR
              </Button>
            </Grid>
          </Grid>
        </ModalComponent>
      ) : null} */}
    </Grid>
  );
};

export default ListadoEstudiantesDocente;
